import { ContactEntity } from "@/constants/forms";

const updateContactMapper = (
  dirtyFields,
  {
  salutation,
  firstname,
  lastname,
  middlename,
  bmw_department,
  suffix,
  jobtitle,
  bmw_position2,
  bmw_position,
  parentcustomerid,
  bmw_contactdetailssource,
  emailaddress1,
  bmw_emailbounceback,
  bmw_primarylanguageid,
  telephone1,
  mobilephone,
  otherPhone,
  bmw_contractsignatory,
  bmw_contractrecipient,
  bmw_influencer,
  bmw_decisionmaker,
  bmw_fleetmanager,
  bmw_authorisedrepresentative,
  bmw_ultimatebeneficialowner,
  bmw_singlesignatoryvehiclecontract,
  bmw_sharedsignatoryvehiclecontract,
  bmw_leasecoprocurementcontact,
  bmw_accountingcontact,
  bmw_address1buildingnumber,
  address1_line1,
  address1_line2,
  address1_line3,
  address1_city,
  bmw_address1_county,
  address1_postalcode,
  address1_postofficebox,
  bmw_country,
  bmw_billingcontact,
  bmw_partnership,
  bmw_salescontact,
  bmw_agreementcontact,
  bmw_keycontact,
  marketingonly,
  bmw_politicallyexposedperson,
  bmw_tobedeletedon,
  bmw_optinavailable,
  bmw_singlesignatoryframeagreement,
  bmw_sharedsignatoryframeagreement,
  bmw_recipientframeagreement,
  bmw_handoverdocumentscontact,
}) => ({
  ...(dirtyFields[ContactEntity.title] && {title: salutation}),
  ...(dirtyFields[ContactEntity.firstName] && {firstName: firstname}),
  ...(dirtyFields[ContactEntity.lastName] && {lastName: lastname}),
  ...(dirtyFields[ContactEntity.middleName] && {middleName: middlename}),
  ...(dirtyFields[ContactEntity.department] && {department: {value: bmw_department ? bmw_department : null}}),
  ...(dirtyFields[ContactEntity.suffix] && {suffix}),
  ...(dirtyFields[ContactEntity.jobTitle] && {jobTitle: jobtitle}),
  ...(dirtyFields[ContactEntity.jobFunction] && {jobFunction: {value: bmw_position2 ? bmw_position2 : null}}),
  ...(dirtyFields[ContactEntity.position] && {position: {value: bmw_position ? bmw_position : null}}),
  ...(dirtyFields[ContactEntity.parentCustomer] && {
    parentCustomer: parentcustomerid
      ? {
          id: parentcustomerid?.id,
          logicalName: parentcustomerid?.logicalName,
          name: parentcustomerid?.name,
        }
      : null,
  }),
  ...(dirtyFields[ContactEntity.dataSource] && {dataSource: bmw_contactdetailssource}),
  ...(dirtyFields[ContactEntity.email] && {email: emailaddress1}),
  ...(dirtyFields[ContactEntity.emailBounceBack] && {emailBounceBack: {value: bmw_emailbounceback ? bmw_emailbounceback : null}}),
  ...(dirtyFields[ContactEntity.primaryLanguage] && {
    primaryLanguage: bmw_primarylanguageid
      ? {
          id: bmw_primarylanguageid?.id,
          logicalName: bmw_primarylanguageid?.logicalName,
          name: bmw_primarylanguageid?.name,
        }
      : null,
  }),
  ...(dirtyFields[ContactEntity.businessPhone] && {businessPhone: telephone1}),
  ...(dirtyFields[ContactEntity.mobilePhone] && {mobilePhone: mobilephone}),
  ...(dirtyFields[ContactEntity.otherPhone] && otherPhone),
  ...(dirtyFields[ContactEntity.signatory] && {signatory: bmw_contractsignatory}),
  ...(dirtyFields[ContactEntity.recipient] && {recipient: bmw_contractrecipient}),
  ...(dirtyFields[ContactEntity.influencer] && {influencer: bmw_influencer}),
  ...(dirtyFields[ContactEntity.decisionMaker] && {decisionMaker: bmw_decisionmaker}),
  ...(dirtyFields[ContactEntity.fleetManager] && {fleetManager: bmw_fleetmanager}),
  ...(dirtyFields[ContactEntity.authorisedRepresentative] && {authorisedRepresentative: bmw_authorisedrepresentative}),
  ...(dirtyFields[ContactEntity.ultimateBeneficialOwner] && {ultimateBeneficialOwner: bmw_ultimatebeneficialowner}),
  ...(dirtyFields[ContactEntity.singleSignatoryVehicleContract] && {singleSignatoryVehicleContract: bmw_singlesignatoryvehiclecontract}),
  ...(dirtyFields[ContactEntity.sharedSignatoryVehicleContract] && {sharedSignatoryVehicleContract: bmw_sharedsignatoryvehiclecontract}),
  ...(dirtyFields[ContactEntity.leaseCoProcurementContact] && {leaseCoprocurementContact: bmw_leasecoprocurementcontact}),
  ...(dirtyFields[ContactEntity.accountingContact] && {accountingContact: bmw_accountingcontact}),
  ...(dirtyFields[ContactEntity.singleSignatoryFrameAgreement] && {singleSignatoryFrameAgreement: bmw_singlesignatoryframeagreement}),
  ...(dirtyFields[ContactEntity.sharedSignatoryFrameAgreement] && {sharedSignatoryFrameAgreement: bmw_sharedsignatoryframeagreement}),
  ...(dirtyFields[ContactEntity.recipientframeagreement] && {recipientFrameAgreement: bmw_recipientframeagreement}),
    ...(dirtyFields[ContactEntity.buildingNumber] && {buildingNumber: bmw_address1buildingnumber}),
  ...(dirtyFields[ContactEntity.street1] && {street1: address1_line1}),
  ...(dirtyFields[ContactEntity.street2] && {street2: address1_line2}),
  ...(dirtyFields[ContactEntity.street3] && {street3: address1_line3}),
  ...(dirtyFields[ContactEntity.city] && {city: address1_city}),
  ...(dirtyFields[ContactEntity.county] && {county: bmw_address1_county
    ? {
        id: bmw_address1_county?.id,
        logicalName: bmw_address1_county?.logicalName,
        name: bmw_address1_county?.name,
      }
    : null}),
  ...(dirtyFields[ContactEntity.postalCode] && {postalCode: address1_postalcode}),
  ...(dirtyFields[ContactEntity.poBox] && {poBox: address1_postofficebox}),
  ...(dirtyFields[ContactEntity.country] && {country: {
    value: bmw_country ? bmw_country : null
  }}),
  ...(dirtyFields[ContactEntity.billing] && {billing: bmw_billingcontact}),
  ...(dirtyFields[ContactEntity.partnership] && {partnership: bmw_partnership}),
  ...(dirtyFields[ContactEntity.sales] && {sales: bmw_salescontact}),
  ...(dirtyFields[ContactEntity.agreement] && {agreement: bmw_agreementcontact}),
  ...(dirtyFields[ContactEntity.keyContact] && {keyContact: bmw_keycontact}),
  ...(dirtyFields[ContactEntity.marketing] && {marketing: marketingonly}),
  ...(dirtyFields[ContactEntity.politicallyExposedPerson] && {politicallyExposedPerson: bmw_politicallyexposedperson}),
  ...(dirtyFields[ContactEntity.toBeDeletedOn] && {toBeDeletedOn: bmw_tobedeletedon}),
  ...(dirtyFields[ContactEntity.dataConsentAvailable] && {dataConsentAvailable: bmw_optinavailable}),
  ...(dirtyFields[ContactEntity.handoverDocumentsContact] && {handoverDocumentsContact: bmw_handoverdocumentscontact}),
  }
);

export { updateContactMapper };
